/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyReturnBills } from 'app/entities/pharmacy-return-bill/pharmacy-return-bill.reducer';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-return-bill-payment.reducer';

export const PharmacyReturnBillPaymentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyReturnBills = useAppSelector(state => state.pharmacyReturnBill.entities);
  const pharmacyReturnBillPaymentEntity = useAppSelector(state => state.pharmacyReturnBillPayment.entity);
  const loading = useAppSelector(state => state.pharmacyReturnBillPayment.loading);
  const updating = useAppSelector(state => state.pharmacyReturnBillPayment.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyReturnBillPayment.updateSuccess);
  const paymentStatusValues = Object.keys(PaymentStatus);

  const handleClose = () => {
    navigate(`/pharmacy-return-bill-payment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyReturnBills({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }

    const entity = {
      ...pharmacyReturnBillPaymentEntity,
      ...values,
      refundBill: pharmacyReturnBills.find(it => it.id.toString() === values.refundBill?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          paymentStatus: 'ENTERED',
          ...pharmacyReturnBillPaymentEntity,
          refundBill: pharmacyReturnBillPaymentEntity?.refundBill?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyReturnBillPayment.home.createOrEditLabel" data-cy="PharmacyReturnBillPaymentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillPayment.home.createOrEditLabel">
              Create or edit a PharmacyReturnBillPayment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-return-bill-payment-id"
                  label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.paymentMethod')}
                id="pharmacy-return-bill-payment-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.transactionDetails')}
                id="pharmacy-return-bill-payment-transactionDetails"
                name="transactionDetails"
                data-cy="transactionDetails"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.paidAmount')}
                id="pharmacy-return-bill-payment-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.active')}
                id="pharmacy-return-bill-payment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.cursor')}
                id="pharmacy-return-bill-payment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.timestampEntry')}
                id="pharmacy-return-bill-payment-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.microSec')}
                id="pharmacy-return-bill-payment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.lastUpdated')}
                id="pharmacy-return-bill-payment-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.paymentStatus')}
                id="pharmacy-return-bill-payment-paymentStatus"
                name="paymentStatus"
                data-cy="paymentStatus"
                type="select"
              >
                {paymentStatusValues.map(paymentStatus => (
                  <option value={paymentStatus} key={paymentStatus}>
                    {translate(`tinyMedicRestApp.PaymentStatus.${paymentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.forCredit')}
                id="pharmacy-return-bill-payment-forCredit"
                name="forCredit"
                data-cy="forCredit"
                check
                type="checkbox"
              />
              <ValidatedField
                id="pharmacy-return-bill-payment-refundBill"
                name="refundBill"
                data-cy="refundBill"
                label={translate('tinyMedicRestApp.pharmacyReturnBillPayment.refundBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyReturnBills
                  ? pharmacyReturnBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/pharmacy-return-bill-payment"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyReturnBillPaymentUpdate;
